(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maps-2"] && !Shopify.designMode) return;
  try {
    

(function () {

  var countries = {
    Singapore: {
      count: '1 Port',
      ports: ['Singapore']
    },
    Malaysia: {
      count: '18 Ports',
      ports: [
        'Penang','Lumut','Kerteh','Kemaman','Kuantan','Port Klang','Malacca',
        'Port Dickson','Pengerang','Pasir Gudang','Tanjung Langsat',
        'Tanjung Pelepas','Kuching','Bintulu','Miri','Labuan','Kimanis',
        'Kota Kinabalu'
      ]
    },
    Indonesia: {
      count: '28 Ports',
      ports: [
        'Arun','Belawan','Dumai','Karimun','Batam','Nipah','Palembang',
        'Cilegon','Cengkareng','Tanjung Priok','Marunda','Tanjung Sekong',
        'Merak','Balongan','Cilacap','Semarang','Tuban','Surabaya',
        'Teluk Lamong','STS Kalbut','Gresik','Pulau Laut','Kotabaru',
        'Balikpapan','Samarinda','Tanjung Bara','Bahodopi','Malili'
      ]
    },
    Thailand: {
      count: '14 Ports',
      ports: [
        'Sriracha','Laemchabang','Bangkok','Prachuap Port','Koh Sichang',
        'Maptaphut & Rayong','Koh Phaluai','Surat Thani','Ranong','Thasala',
        'Songkhla','Phuket','Kantang','Krabi'
      ]
    },
    Vietnam: {
      count: '7 Ports',
      ports: [
        'Quang Ninh','Hai Phong','Da Nang','Dong Nai',
        'Ho Chi Minh','Phu My Cai Mep','Vung Tau'
      ]
    },
    Bangladesh: {
      count: '3 Ports',
      ports: ['Mongla','Chittagong','Matarbari Deep Sea Port']
    },
    India: {
      count: '36 Ports',
      ports: [
        'Kandla','Mundra','Salaya','Vadinar','Okha','Sikka','Porbandar',
        'Pipavav','Navlakhi','Bedi','Bhavnagar','Dahej','Hazira','Magdalla',
        'Haji Bandar','Mumbai','Dharamtar','Revdanda','Redi','Mormugao','JNPT',
        'New Mangalore','Cochin','Tuticorin','Karaikal','Chennai','Kattupalli',
        'Ennore','Krishnapatnam','Kakinada','Vizag','Gopalpur','Dhamra',
        'Paradip','Haldia','Kolkata'
      ]
    }
  };

  var tooltip    = document.querySelector('.sg2-tooltip');
  var mapWrapper = document.querySelector('.sg2-map-wrapper');
  var mapScroll  = document.querySelector('.sg2-map-scroll');
  var titleEl    = document.querySelector('.sg2-country-title');
  var countEl    = document.querySelector('.sg2-port-count');
  var portList   = document.querySelector('.sg2-port-list');
  var markers    = document.querySelectorAll('.sg2-marker');
  var cards      = document.querySelectorAll('.sg2-country-card');

  function renderCountry(country) {
    if (!countries[country]) return;
    titleEl.textContent = country;
    countEl.textContent = countries[country].count;
    portList.innerHTML = countries[country].ports.map(function(port, i) {
      return '<div class="sg2-port-item"><span>' + String(i + 1).padStart(2,'0') + '</span>' + port + '</div>';
    }).join('');
    markers.forEach(function(m) {
      m.classList.toggle('active', m.dataset.country === country);
    });
    cards.forEach(function(c) {
      c.classList.toggle('active', c.dataset.country === country);
    });
  }

  function scrollMarkerIntoView(marker) {
    if (!mapScroll || !marker) return;
    var targetLeft = marker.offsetLeft - (mapScroll.clientWidth / 2);
    mapScroll.scrollTo({ left: targetLeft, behavior: 'smooth' });
  }

  markers.forEach(function(marker) {
    marker.addEventListener('click', function() {
      renderCountry(this.dataset.country);
      scrollMarkerIntoView(this);
    });
    marker.addEventListener('mousemove', function(e) {
      tooltip.style.display = 'block';
      tooltip.textContent = this.dataset.country;
      var rect = mapWrapper.getBoundingClientRect();
      tooltip.style.left = (e.clientX - rect.left + 20) + 'px';
      tooltip.style.top  = (e.clientY - rect.top  - 20) + 'px';
    });
    marker.addEventListener('mouseleave', function() {
      tooltip.style.display = 'none';
    });
  });

  cards.forEach(function(card) {
    card.addEventListener('click', function() {
      renderCountry(this.dataset.country);
      var marker = document.querySelector('.sg2-marker.' + this.dataset.country.toLowerCase());
      scrollMarkerIntoView(marker);
    });
  });

  renderCountry('Singapore');

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-global-network"] && !Shopify.designMode) return;
  try {
    

(function () {

  var countries = {
    Singapore: {
      count: '1 Port',
      ports: ['Singapore']
    },
    Malaysia: {
      count: '18 Ports',
      ports: [
        'Penang','Lumut','Kerteh','Kemaman','Kuantan','Port Klang','Malacca',
        'Port Dickson','Pengerang','Pasir Gudang','Tanjung Langsat',
        'Tanjung Pelepas','Kuching','Bintulu','Miri','Labuan','Kimanis',
        'Kota Kinabalu'
      ]
    },
    Indonesia: {
      count: '28 Ports',
      ports: [
        'Arun','Belawan','Dumai','Karimun','Batam','Nipah','Palembang',
        'Cilegon','Cengkareng','Tanjung Priok','Marunda','Tanjung Sekong',
        'Merak','Balongan','Cilacap','Semarang','Tuban','Surabaya',
        'Teluk Lamong','STS Kalbut','Gresik','Pulau Laut','Kotabaru',
        'Balikpapan','Samarinda','Tanjung Bara','Bahodopi','Malili'
      ]
    },
    Thailand: {
      count: '14 Ports',
      ports: [
        'Sriracha','Laemchabang','Bangkok','Prachuap Port','Koh Sichang',
        'Maptaphut & Rayong','Koh Phaluai','Surat Thani','Ranong','Thasala',
        'Songkhla','Phuket','Kantang','Krabi'
      ]
    },
    Vietnam: {
      count: '7 Ports',
      ports: [
        'Quang Ninh','Hai Phong','Da Nang','Dong Nai',
        'Ho Chi Minh','Phu My Cai Mep','Vung Tau'
      ]
    },
    Bangladesh: {
      count: '3 Ports',
      ports: ['Mongla','Chittagong','Matarbari Deep Sea Port']
    },
    India: {
      count: '36 Ports',
      ports: [
        'Kandla','Mundra','Salaya','Vadinar','Okha','Sikka','Porbandar',
        'Pipavav','Navlakhi','Bedi','Bhavnagar','Dahej','Hazira','Magdalla',
        'Haji Bandar','Mumbai','Dharamtar','Revdanda','Redi','Mormugao','JNPT',
        'New Mangalore','Cochin','Tuticorin','Karaikal','Chennai','Kattupalli',
        'Ennore','Krishnapatnam','Kakinada','Vizag','Gopalpur','Dhamra',
        'Paradip','Haldia','Kolkata'
      ]
    }
  };

  var tooltip     = document.querySelector('.sg-tooltip');
  var mapWrapper  = document.querySelector('.sg-map-wrapper');
  var mapScroll   = document.querySelector('.sg-map-scroll');
  var titleEl     = document.querySelector('.sg-country-title');
  var countEl     = document.querySelector('.sg-port-count');
  var portList    = document.querySelector('.sg-port-list');
  var markers     = document.querySelectorAll('.sg-marker');
  var cards       = document.querySelectorAll('.sg-country-card');

  var panel       = document.querySelector('.sg-port-panel');
  var backdrop    = document.querySelector('.sg-sheet-backdrop');
  var closeBtn    = document.querySelector('.sg-sheet-close');
  var searchWrap  = document.querySelector('.sg-port-search-wrap');
  var searchInput = document.querySelector('.sg-port-search');

  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function renderCountry(country) {
    if (!countries[country]) return;
    titleEl.textContent = country;
    countEl.textContent = countries[country].count;
    portList.innerHTML = countries[country].ports.map(function(port, i) {
      return '<div class="sg-port-item"><span>' + String(i + 1).padStart(2,'0') + '</span>' + port + '</div>';
    }).join('');
    markers.forEach(function(m) {
      m.classList.toggle('active', m.dataset.country === country);
    });
    cards.forEach(function(c) {
      c.classList.toggle('active', c.dataset.country === country);
    });

    searchInput.value = '';
    searchWrap.style.display = countries[country].ports.length > 10 ? 'block' : 'none';
  }

  function scrollMarkerIntoView(marker) {
    if (!mapScroll || !marker) return;
    var targetLeft = marker.offsetLeft - (mapScroll.clientWidth / 2);
    mapScroll.scrollTo({ left: targetLeft, behavior: 'smooth' });
  }

  function openSheet() {
    if (!isMobile()) return;
    panel.classList.add('active');
    backdrop.classList.add('active');
  }

  function closeSheet() {
    panel.classList.remove('active');
    backdrop.classList.remove('active');
  }

  markers.forEach(function(marker) {
    marker.addEventListener('click', function() {
      renderCountry(this.dataset.country);
      scrollMarkerIntoView(this);
      openSheet();
    });
    marker.addEventListener('mousemove', function(e) {
      if (isMobile()) return;
      tooltip.style.display = 'block';
      tooltip.textContent = this.dataset.country;
      var rect = mapWrapper.getBoundingClientRect();
      tooltip.style.left = (e.clientX - rect.left + 20) + 'px';
      tooltip.style.top  = (e.clientY - rect.top  - 20) + 'px';
    });
    marker.addEventListener('mouseleave', function() {
      tooltip.style.display = 'none';
    });
  });

  cards.forEach(function(card) {
    card.addEventListener('click', function() {
      renderCountry(this.dataset.country);
      var marker = document.querySelector('.sg-marker.' + this.dataset.country.toLowerCase());
      scrollMarkerIntoView(marker);
      openSheet();
    });
  });

  backdrop.addEventListener('click', closeSheet);
  closeBtn.addEventListener('click', closeSheet);

  searchInput.addEventListener('input', function() {
    var q = this.value.trim().toLowerCase();
    portList.querySelectorAll('.sg-port-item').forEach(function(item) {
      var match = item.textContent.toLowerCase().indexOf(q) !== -1;
      item.classList.toggle('sg-hidden', !match);
    });
  });

  renderCountry('Singapore');

  // On mobile, open straight onto the busy Southeast Asia cluster
  // on the right side of the map instead of the empty left edge.
  if (isMobile()) {
    scrollMarkerIntoView(document.querySelector('.sg-marker.singapore'));
  }

})();


  } catch(e) { console.error(e); }
})();
})();
